import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Relations from "../pages/relations/page";
import CpLines from "../pages/cp-lines/page";
import Daily from "../pages/daily/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/relations",
    element: <Relations />,
  },
  {
    path: "/cp-lines",
    element: <CpLines />,
  },
  {
    path: "/daily",
    element: <Daily />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;